import type { RichTextContentProtocol } from '@lighthouse/core'

export const ORDER_NUMBER_TYPE_OPTIONS = [
    { label: '商户订单号', value: '1' },
    { label: '微信支付单号', value: '2' }
]

export const LOGISTICS_TYPE_OPTIONS = [
    { label: '快递', value: '1' },
    { label: '同城配送', value: '2' },
    { label: '虚拟商品', value: '3' },
    { label: '用户自提', value: '4' }
]

export const DELIVERY_MODE_OPTIONS = [
    { label: '统一发货', value: '1' },
    { label: '分拆发货', value: '2' }
]

export const ORDER_STATE_OPTIONS = [
    { label: '不筛选', value: '' },
    { label: '待发货', value: '1' },
    { label: '已发货', value: '2' },
    { label: '确认收货', value: '3' },
    { label: '交易完成', value: '4' },
    { label: '已退款', value: '5' },
    { label: '资金待结算', value: '6' }
]

export const ORDER_NUMBER_TYPE_OUT_TRADE_NO = 1
export const ORDER_NUMBER_TYPE_TRANSACTION_ID = 2
export const LOGISTICS_TYPE_EXPRESS = 1
export const DELIVERY_MODE_SPLIT = 2

export const toPlainRichText = (text: string): RichTextContentProtocol => ({
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: text ? [{ type: 'text', text }] : []
        }
    ]
})
